<template>
  <div
    class="country-avatar"
    :class="[`country-avatar--${size}`]"
    :style="avatarStyle"
    :title="displayLabel"
    role="img"
    :aria-label="displayLabel"
  >
    <span class="country-avatar__initials">{{ initials }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults } from 'vue'
import {
  getCountryAvatarColor,
  getCountryAvatarSizePx,
  getCountryInitials,
  type CountryAvatarSize,
} from '@/utils/countryAvatar'

const props = withDefaults(defineProps<{
  country?: string | null
  fallbackLabel?: string | null
  size?: CountryAvatarSize
}>(), {
  country: '',
  fallbackLabel: '',
  size: 'md',
})

const displayLabel = computed(() => props.country || props.fallbackLabel || '')
const initials = computed(() => getCountryInitials(props.country, props.fallbackLabel || undefined))
const avatarStyle = computed(() => ({
  width: `${getCountryAvatarSizePx(props.size)}px`,
  height: `${getCountryAvatarSizePx(props.size)}px`,
  backgroundColor: getCountryAvatarColor(props.country || props.fallbackLabel),
}))
</script>

<style scoped>
.country-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  border: 2px solid var(--colour-icons, var(--colour-surface-cont-high));
  box-sizing: border-box;
}

.country-avatar__initials {
  color: #fff;
  font-family: var(--typography-font-family, 'Ubuntu', sans-serif);
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  user-select: none;
}

.country-avatar--sm .country-avatar__initials {
  font-size: 13px;
}

.country-avatar--md .country-avatar__initials {
  font-size: 15px;
}

.country-avatar--lg .country-avatar__initials {
  font-size: 22px;
}
</style>
